import {
  fork,
  put,
  all,
  call,
  takeLeading,
  takeLatest,
  take,
  cancel,
  select,
} from 'redux-saga/effects';
import types from './actionTypes';
import * as surveyFormsActions from './actions';
import {
  getFirestore,
  query,
  collection,
  doc,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import rsf from '../../helpers/firebase';
import toastr from 'toastr';

const db = getFirestore(rsf.app);

const surveyFormTransformer = (payload) => {
  let surveyForms = [];

  payload.forEach((surveyForm) => {
    const data = surveyForm.data();

    surveyForms.push({
      id: surveyForm.id,
      ...data,
      ...(data.headerCSV && { headerCSVArray: data.headerCSV.split(',') }),
    });
  });

  return surveyForms;
};

function* syncSurveyFormsSaga() {
  const companyId = yield select((state) => state.Dashboard.companyId);
  const surveyFormsRef = query(
    collection(db, 'surveyForms'),
    where('companyId', '==', companyId),
    orderBy('name', 'asc'),
  );

  const task = yield fork(rsf.firestore.syncCollection, surveyFormsRef, {
    successActionCreator: surveyFormsActions.syncSurveyFormsSuccess,
    failureActionCreator: surveyFormsActions.syncSurveyFormsFailure,
    transform: (payload) => surveyFormTransformer(payload),
  });

  yield take(types.RESET_SURVEY_FORM_STATE);
  yield cancel(task);
}

function* createSurveyFormSaga({ surveyForm }) {
  try {
    const db = getFirestore(rsf.app);
    const surveyFormsRef = collection(db, 'surveyForms');
    const companyId = yield select((state) => state.Dashboard.companyId);

    yield call(rsf.firestore.addDocument, surveyFormsRef, {
      ...surveyForm,
      companyId,
    });
    yield put(surveyFormsActions.createSurveyFormSuccess(surveyForm));
    toastr.success('SurveyForm created!', '');
  } catch (error) {
    yield put(surveyFormsActions.createSurveyFormFailure(error));
  }
}

function* updateSurveyFormSaga({ surveyForm }) {
  try {
    const surveyFormsRef = doc(db, 'surveyForms', surveyForm.id);
    delete surveyForm.id;

    yield call(
      rsf.firestore.setDocument,
      surveyFormsRef,
      {
        ...surveyForm,
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );
    yield put(surveyFormsActions.updateSurveyFormSuccess(surveyForm));
    toastr.success('SurveyForm updated!', '');
  } catch (error) {
    yield put(surveyFormsActions.updateSurveyFormFailure(error));
  }
}

function* surveyFormSaga() {
  yield all([
    takeLatest(types.SYNC_SURVEY_FORMS.REQUEST, syncSurveyFormsSaga),
    takeLeading(types.CREATE_SURVEY_FORM.REQUEST, createSurveyFormSaga),
    takeLeading(types.UPDATE_SURVEY_FORM.REQUEST, updateSurveyFormSaga),
  ]);
}

export default surveyFormSaga;
